import {defineStore} from "pinia";

const useHistoryStore = defineStore({
    id: "history",
    state: () => {
        return {
            historyList: [],
            localMusicList: []
        }
    },
    actions: {
        addHistoryList(item) {
            let index = this.historyList.indexOf(item)
            if (index !== -1) {
                this.historyList.splice(index, 1);
                this.historyList.unshift(item);
            } else {
                this.historyList.unshift(item);
            }
            this.historyList = this.historyList.slice(0, 10);
        },
        removeHistoryList() {
            this.historyList = []
        },
        addLocalMusicList(item) {
            let index = this.localMusicList.findIndex(i => {
                return i.rid == item.rid
            })
            if (index !== -1) {
                this.localMusicList.splice(index, 1);
                this.localMusicList.unshift(item);
            } else {
                this.localMusicList.unshift(item);
            }
            this.localMusicList = this.localMusicList.slice(0, 100);
        },
        removeLocalMusicList(list) {
            list.forEach(item=>{
                let index = this.localMusicList.findIndex(i => {
                    return i.rid == item.rid
                })
                if (index !== -1) {
                    this.localMusicList.splice(index, 1);
                }
            })
        },
    },
    getters: {},
    persist: {
        enabled: true,
        strategies: [
            {storage: localStorage, paths: ['historyList','localMusicList']},
        ],
    },
})

export default useHistoryStore
